export const routes = Object.freeze({
  SEARCH_PAGE: 'SEARCH_PAGE',
  RAW_DATA_PAGE: 'RAW_DATA_PAGE',
  SETTINGS_PAGE: 'SETTINGS_PAGE',
  LOGOUT_PAGE: 'LOGOUT_PAGE',
  ASSET_DETAIL_PAGE: 'ASSET_DETAIL_PAGE',
});

export const BREADCRUMB_LABELS = Object.freeze({
  HOME: 'Home',
  SEARCH: 'Search',
  SITE: 'Site_Details',
  EQUIPMENT: 'Equipment_Details',
  SITE_LIST: 'Site_List',
  INVENTORY_SITE_LIST: 'Inventory_Site_List',
  TRENDS_VIEW: 'Portfolio_Trend',
  TEMPERATURE_AND_CONSUMPTION: 'Temperature_and_consumption_view',
  LIVECONNECT: 'Live_Connect',
  ADR: 'Automated_Demand_Response',
  EQUIPMENT_TRENDS_VIEW: 'Equipment_Portfolio_Trend',
  OPPORTUNITY_TRENDS_VIEW: 'Equipment_Portfolio_Trend',
  HELP_CENTER: 'Help_Center',
});

export const customBreadcrumbs = {
  siteList: [
    { key: '/home', label: BREADCRUMB_LABELS.HOME },
    {
      key: '/site-list',
      label: BREADCRUMB_LABELS.SITE_LIST,
    },
  ],
  inventorySitList: [
    { key: '/home', label: BREADCRUMB_LABELS.HOME },
    {
      key: '/inventory-site-list',
      label: BREADCRUMB_LABELS.INVENTORY_SITE_LIST,
    },
  ],
  trends: [
    { key: '/home', label: BREADCRUMB_LABELS.HOME },
    {
      key: '/trends-view',
      label: BREADCRUMB_LABELS.TRENDS_VIEW,
    },
  ],
  temperature: [
    { key: '/home', label: BREADCRUMB_LABELS.HOME },
    { key: '/search', label: BREADCRUMB_LABELS.SEARCH },
    {
      key: '/temperature-and-consumption',
      label: BREADCRUMB_LABELS.TEMPERATURE_AND_CONSUMPTION,
    },
  ],
  liveConnect: [
    { key: '/home', label: BREADCRUMB_LABELS.HOME },
    { key: '/search', label: BREADCRUMB_LABELS.SEARCH },
    {
      key: '/live-connect',
      label: BREADCRUMB_LABELS.LIVECONNECT,
    },
  ],
  adr: [
    { key: '/home', label: BREADCRUMB_LABELS.HOME },
    { key: '/search', label: BREADCRUMB_LABELS.SEARCH },
    {
      key: '/adr',
      label: BREADCRUMB_LABELS.ADR,
    },
  ],
  helpCenter: [
    {
      key: '/home',
      label: BREADCRUMB_LABELS.HOME,
    },
    {
      key: '/help-center',
      label: BREADCRUMB_LABELS.HELP_CENTER,
    },
  ],
  equipmentTrendsView: [
    {
      key: '/home',
      label: BREADCRUMB_LABELS.HOME,
    },
    {
      key: '/overall-trends-view',
      label: BREADCRUMB_LABELS.TRENDS_VIEW,
    },
    {
      key: '/trends-view/equipment',
      label: BREADCRUMB_LABELS.EQUIPMENT_TRENDS_VIEW,
    },
  ],
  opportunityTrendsView: [
    {
      key: '/home',
      label: BREADCRUMB_LABELS.HOME,
    },
    {
      key: '/overall-trends-view',
      label: BREADCRUMB_LABELS.TRENDS_VIEW,
    },
    {
      key: '/trends-view/opportunity',
      label: BREADCRUMB_LABELS.OPPORTUNITY_TRENDS_VIEW,
    },
  ],
};

export const siteDetailRoutes = Object.freeze({
  active: 'active',
  hold: 'hold',
  history: 'history',
  bookmark: 'bookmark',
  ageInDays: 'ageInDays',
});

export const assetDetailsUrls = Object.freeze({
  details: 'details',
  history: 'history',
});

export const tabPage = {
  home: 'home',
  summary: 'summary',
  history: 'history',
  live: 'live',
  portfolio: 'portfolio',
};

export const navigationView = [
  { key: 'mapView', value: 'Map_View' },
  { key: 'listView', value: 'List_View' },
];

export const launchPageView = [
  { key: 'portfolioHealthMap', value: 'Portfolio_Summary_Health_Map' },
  {
    key: 'equipmentPortfolioHealth',
    value: 'Equipment_Portfolio_Health_Dashboard',
  },
  { key: 'customLaunchView', value: 'Custom_Launch_View' },
];
export const initLaunchPage = 'portfolioHealthMap';
export const initNavigation = 'mapView';

export const portfolioNav = {
  healthView: 'healthView',
  mapView: 'mapView',
  customLaunchView: 'customLaunchView',
};

export const AIS_ACTIVE = '/site-details/ais/active';
export const PAI_ACTIVE = '/site-details/pai/active';
export const PORTFOLIO = '/insights/home';
export const LIVE_CONNECT = '/live-connect';
export const SITE_LIST = '/site-list';
export const TRENDS_VIEW = '/trends-view';
export const userAssociationPath = '/user-association';

export const toDolistNavSubMenuLists = [
  {
    id: 'siteDetailsActionableList',
    label: 'To_do_list',
    toolTipMsg: 'View_all_Active_(Urgent_and_Plan)_Actionables',
    disabled: false,
    hidden: false,
  },
  {
    id: 'siteDetailsActionableHistory',
    label: 'History',
    toolTipMsg: 'View_History_of_Actionables',
    disabled: false,
    hidden: false,
  },
  {
    id: 'siteDetailsActionableHold',
    label: 'Hold',
    toolTipMsg: 'View_Actionables_on_hold',
    disabled: false,
    hidden: false,
  },
  {
    id: 'siteDetailsActionableBookmark',
    label: 'Bookmarked',
    toolTipMsg: 'View_all_bookmarked_Actionables',
    disabled: false,
    hidden: false,
  },
];
